module.exports = __webpack_public_path__ + "img/paifeng.84b78183.png";